import { ContainerBoxInterface } from '@peakconcepts/landingpage-kit'
import colors from '../../default/colors'

const data: ContainerBoxInterface = {
  containers: [
    {
      classNames: 'container',
      padding: {
        fullHd: '80px 0',
        widescreen: '80px 0',
        desktop: '80px 40px',
        tablet: '60px 40px',
        mobile: '40px 20px'
      },
      containers: [
        {
          classNames: 'columns is-multiline',
          containers: [
            {
              classNames: 'column is-full',
              defaultCss: {
                background: colors.header
              },
              padding: {
                fullHd: '80px 0',
                widescreen: '80px 0',
                desktop: '80px 40px',
                tablet: '60px 40px',
                mobile: '40px 20px'
              },
              containers: [
                {
                  type: 'text',
                  config: {
                    size: 2,
                    fontSize: {
                      desktop: '32px',
                      tablet: '24px',
                      mobile: '16px'
                    },
                    margin: {
                      desktop: '0 0 30px',
                      tablet: '0 0 30px',
                      mobile: '0 0 30px'
                    },
                    defaultCss: {
                      color: '#fff'
                    },
                    text: 'Deine Anfrage war erfolgreich ✅'
                  }
                },
                {
                  type: 'text',
                  config: {
                    fontSize: {
                      desktop: '20px',
                      tablet: '20px',
                      mobile: '16px'
                    },
                    margin: { desktop: '0', tablet: '0', mobile: '0' },
                    defaultCss: {
                      textAlign: 'center',
                      color: '#fff'
                    },
                    text:
                      'An dieser Stelle möchte ich mich für Dein Vertrauen bedanken!'
                  }
                }
              ]
            },
            {
              classNames: 'column is-full',
              padding: {
                desktop: '80px 40px',
                tablet: '60px 30px',
                mobile: '40px 15px'
              },
              defaultCss: {
                boxShadow: '0 1px 5px rgb(0 0 0 / 20%)',
                media: [
                  {
                    breakpoint: 'mobile',
                    css: { boxShadow: 'none' }
                  }
                ]
              },
              containers: [
                {
                  type: 'text',
                  config: {
                    size: 2,
                    text: 'Wie geht es jetzt weiter?'
                  }
                },
                {
                  type: 'text',
                  config: {
                    fontSize: {
                      desktop: '20px',
                      tablet: '20px',
                      mobile: '18px'
                    },
                    margin: {
                      desktop: '0 200px 40px',
                      tablet: '0',
                      mobile: '0'
                    },
                    defaultCss: {
                      textAlign: 'center'
                    },
                    text:
                      'Du bekommst schon bald die Möglichkeit zu <u>100% kostenlos</u> all Deine Fragen zu stellen und Dich genau über die Zusammenarbeit mit mir zu informieren.<br/><br/> Um Dir deine Fragen bis ins kleinste Detail beantworten zu können, kontaktiere ich Dich an Deinem ausgewählten Termin telefonisch. <br/><br/><b>Ich freue mich auf Dich.</b><br/><br/><br/>Viele Grüße <br/> Manfred Krause'
                  }
                }
              ]
            }
          ]
        }
      ]
    }
  ]
}

export default data
